<div
  id="moveableContainer"
  class="wrapper wrapper-content animated fadeInLeft exchangeTokensContainer"
>
  <!-- <div id="header" class="display-flex-left flex-align-center">
    <h1>
        <a (click)="goBack()"><i class="fa fa-angle-left"></i></a>
        &nbsp;
        {{ 'Menu.Plans' | translate }}
    </h1>
  </div> -->
  <div class="display-flex-left plans-margin">
    <div class="no-padding" id="sideHistory">
      <div class="" id="wrapper">
        <div id="addNewButton" (click)="newPlan()">
          {{ 'ADMIN_LTI.NEW' | translate | uppercase }}
        </div>
        <div id="help" class="display-flex-space-between">
          <div (click)="showHelp()">
            <i class="fa fa-info-circle"></i>
            &nbsp;{{ 'ADMIN_LTI.HELP' | translate }}
          </div>
        </div>
        <div id="sideHistoryTitle" *ngIf="sideHistoryItems">
          {{ 'ADMIN_LTI.SAVED_PLANS' | translate }}
        </div>
        <div
          class="sideHistoryItem"
          *ngFor="let item of sideHistoryItems; let i = index"
          [ngClass]="{
            selected: isSelected(item),
            bozza: item.IsDraft && !item.IsReviewing,
            definitivo: item.active,
            review: item.IsReviewing
          }"
          (click)="setCurrentPlan(item)"
        >
          <div class="sideHistoryItem-wrapper">
            <div class="title">
              <div class="sideHistoryItemTitle">
                <i
                  *ngIf="item.active"
                  class="fa fa-get-pocket"
                  aria-hidden="true"
                ></i>
                <i
                  *ngIf="item.IsDraft && !item.IsReviewing"
                  class="fa fa-file-o"
                  aria-hidden="true"
                ></i>
                <i
                  *ngIf="item.IsReviewing"
                  class="fa fa-pencil-square-o"
                  aria-hidden="true"
                ></i>
                {{ item.Name }}
              </div>
              <div class="sideHistoryItemExpiration">
                <span class="text-small" *ngIf="!item.IsDraft">
                  {{ 'ADMIN_LTI.SENT_ON' | translate }}
                  {{
                    'DYNAMIC_DATE'
                      | translate: { date: item.ActivationDate | localizedDate }
                  }}
                </span>
                <span class="text-small" *ngIf="item.IsDraft">
                  {{ 'ADMIN_LTI.SAVED_ON' | translate }}
                  {{
                    'DYNAMIC_DATE'
                      | translate: { date: item.Date | localizedDate }
                  }}
                </span>
                <span class="text-small" *ngIf="!item.Expires || !item.IsDraft">
                  &nbsp;
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="separator_v"></div>

    <div class="no-padding flex-fill-width" id="mainContainer">
      <div class="ibox float-e-margins" id="">
        <div class="ibox-content1" *ngIf="currentPlan && employeesList">
          <div class="display-flex-left">
            <!-- [ngClass]="{'fullWidth': currentTabIndex === 5}"-->
            <div id="tabsetContainer">
              <!-- {{currentPlan | json}} -->
              <div
                id="timespan_participants_header"
                *ngIf="currentTabIndex == 0 && !currentPlan.IsActive"
              >
                <div class="display-flex-left">
                  <div class="timespan_participants_header_item">
                    <div class="timespan_participants_header_item_title">
                      {{ 'ADMIN_LTI.TIME_PART.HEADER.PLAN_NAME' | translate }}
                    </div>
                    <input
                      type="text"
                      name=""
                      [(ngModel)]="currentPlan.Name"
                      class="form-control"
                      (ngModelChange)="onChangeName()"
                    />
                  </div>
                  <div class="timespan_participants_header_item">
                    <div class="timespan_participants_header_item_title">
                      {{
                        'ADMIN_LTI.TIME_PART.HEADER.PLAN_TIMESPAN' | translate
                      }}
                    </div>
                    <div class="display-flex-left">
                      <div class="display-flex-left flex-align-center">
                        <label for="">{{ 'FROM' | translate }}</label>
                        <div class="">&nbsp;</div>
                        <select
                          class="form-control"
                          name="sel-activity"
                          [(ngModel)]="currentPlan.YearStart"
                          (ngModelChange)="onChangeYearStart()"
                        >
                          <option
                            *ngFor="let year of getPlanFromYear()"
                            [ngValue]="year"
                          >
                            {{ year }}
                          </option>
                          <!--[disabled]="year>=currentPlan.YearEnd"-->
                        </select>
                      </div>
                      <div class="" style="flex: 0 0 20px">&nbsp;</div>
                      <div class="display-flex-left flex-align-center">
                        <label for="">{{ 'TO' | translate }}</label>
                        <div class="">&nbsp;</div>
                        <select
                          class="form-control"
                          name="sel-activity"
                          [(ngModel)]="currentPlan.YearEnd"
                          (ngModelChange)="onChangeYearEnd()"
                        >
                          <option
                            *ngFor="let year of getPlanToYear()"
                            [ngValue]="year"
                            [disabled]="year < currentPlan.YearStart"
                          >
                            {{ year }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="gateways"
                *ngIf="currentTabIndex > 0 || currentPlan.IsActive"
              >
                <div id="gateways_header">
                  <div id="gateways_header_plan_name">
                    <div class="gateways_header_item_title">
                      <span *ngIf="currentPlan.Name">
                        {{ currentPlan.Name }}
                      </span>
                      <span *ngIf="!currentPlan.Name">
                        {{
                          'ADMIN_LTI.GATEWAYS.HEADER.SET_PLAN_NAME' | translate
                        }}
                      </span>
                    </div>
                  </div>
                  <div id="gateways_header_plan_time_span">
                    <div class="display-flex-left flex-align-baseline">
                      <label for="">{{ 'FROM' | translate }}</label>
                      <div class="">&nbsp;</div>
                      <span for="">{{ currentPlan.YearStart }}</span>
                    </div>
                    <div class="" style="flex: 0 0 20px">&nbsp;</div>
                    <div class="display-flex-left flex-align-baseline">
                      <label for="">{{ 'TO' | translate }}</label>
                      <div class="">&nbsp;</div>
                      <span for="">{{ currentPlan.YearEnd }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <br />

              <tabset [justified]="true">
                <!-- Time Span & Participants -->
                <tab
                  (selectTab)="onSelectTab($event, 0)"
                  heading="{{ 'ADMIN_LTI.TABS.TIME_PART' | translate }}"
                >
                  <div
                    id="timespan_participants"
                    *ngIf="currentPlan.IsActive || currentPlan.IsReviewing"
                  >
                    <div id="timespan_participants_body">
                      <!--
                      <div id="timespan_participants_body_Employee_typeahead_title" *ngIf="!editParticipants">
                        <a href="javascript:void(0)" (click)="enableEditParticipants()"
                          class="text-blue medium bold">{{'ADMIN_LTI.TIME_PART.BODY.EDIT_PARTICIPANTS' | translate}}</a>
                      </div>
                      -->
                      <div
                        class="col-xs-12"
                        id="timespan_participants_body_paticipants_list_container"
                        *ngIf="
                          currentPlan.PartecipantsByYear[0].Partecipants
                            .length > 0
                        "
                      >
                        <!--<div id="result_detail-container" *ngIf="editParticipants">-->
                        <div id="result_detail-container">
                          <div id="resultsView">
                            <div class="result_detail-switch">
                              <div
                                class="result_detail-switch_item"
                                (click)="currentYear = year"
                                *ngFor="
                                  let year of plansLength();
                                  let i = index
                                "
                                [ngClass]="{ active: currentYear == year }"
                              >
                                {{ currentPlan.YearStart + i }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--
                        <div class="lightgrey border-top min-padding-vertical" *ngIf="!isEditable()">
                          <i class="fa fa-exclamation"></i>
                          {{'ADMIN_LTI.TIME_PART.BODY.EDIT_PARTICIPANTS_HINT' | translate}}
                        </div>
                        -->
                        <div
                          id="timespan_participants_body_Employee_typeahead_title"
                          *ngIf="isEditable()"
                        >
                          {{
                            'ADMIN_LTI.TIME_PART.BODY.ADD_PARTICIPANTS'
                              | translate
                          }}
                        </div>
                        <div
                          class="display-flex-left flex-align-center"
                          *ngIf="isEditable()"
                        >
                          <div class="input-compare-item">
                            <input
                              id="timespan_participants_body_input_typeahead"
                              [(ngModel)]="searchedEmployee"
                              placeholder="{{
                                'Generic.SearchEmployee' | translate
                              }}"
                              [typeaheadMinLength]="0"
                              [typeahead]="getFilteredEmployeeList()"
                              [typeaheadOptionsLimit]="employeesList.length"
                              (typeaheadOnSelect)="
                                onSelectEmployeeEdit($event?.item)
                              "
                              [ngClass]="{ 'bg-blue': searchedSkill }"
                              [typeaheadItemTemplate]="employeeTemplate"
                              typeaheadOptionField="Name"
                              class="form-control pull-right search-skill-input"
                            />
                          </div>
                        </div>
                        <table>
                          <thead>
                            <tr>
                              <th class="small">
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.PARTICIPANTS_LIST_TABLE.TH.EMPLOYEE'
                                    | translate
                                }}
                              </th>
                              <th class="small">
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.PARTICIPANTS_LIST_TABLE.TH.RAL'
                                    | translate
                                }}
                              </th>
                              <th class="small">
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.PARTICIPANTS_LIST_TABLE.TH.TARGET_BONUS_PERC'
                                    | translate
                                }}
                              </th>
                              <th class="small">
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.PARTICIPANTS_LIST_TABLE.TH.TARGET_BONUS_CURR'
                                    | translate
                                }}({{ parameters.Currency }})
                              </th>
                              <th *ngIf="isEditable()"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="
                                let participant of getPartecipantsByYear(
                                  currentYear
                                );
                                let i = index
                              "
                            >
                              <td class="participantEmployee">
                                <div
                                  class="display-flex-left flex-align-center"
                                >
                                  <img
                                    class="user-image-round-bordered"
                                    [src]="
                                      coreService.getImageURL(
                                        participant.Picture,
                                        'assets/images/user.jpeg'
                                      )
                                    "
                                  />
                                  <div class="participantEmployeeName">
                                    {{ participant.SecondName }}
                                    {{ participant.FirstName }}
                                  </div>
                                </div>
                              </td>
                              <td class="participantGrossAnnualSalary">
                                <div class="input-group">
                                  <input
                                    [disabled]="!isEditable()"
                                    OnlyNumber="true"
                                    (keyup)="checkTargetBonusEdit(participant)"
                                    type="text"
                                    name=""
                                    [(ngModel)]="participant.GrossAnnualSalary"
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      {{ parameters.Currency }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td class="participantTargetBonusPercentage">
                                <div class="input-group">
                                  <input
                                    [disabled]="!isEditable()"
                                    OnlyNumber="true"
                                    (keyup)="checkTargetBonusEdit(participant)"
                                    type="text"
                                    name=""
                                    [(ngModel)]="
                                      participant.TargetBonusPercentage
                                    "
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <span class="input-group-text">%</span>
                                  </div>
                                </div>
                              </td>
                              <td class="participantTargetBonus">
                                <input
                                  OnlyNumber="true"
                                  type="text"
                                  name=""
                                  [ngModel]="
                                    formatNumber(participant.TargetBonus, 2)
                                  "
                                  class="form-control"
                                  disabled
                                />
                              </td>
                              <td
                                class="participantAction"
                                *ngIf="isEditable()"
                              >
                                <a
                                  class="text-grey"
                                  (click)="removeParticipantEdit(participant)"
                                >
                                  <i class="fa fa-trash"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="2" class="total">
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.PARTICIPANTS_LIST_TABLE.TFOOT.TOTAL'
                                    | translate
                                }}
                              </th>
                              <th colspan="2" class="text-right">
                                {{ formatNumber(getTotTable()) }}
                              </th>
                              <th *ngIf="isEditable()"></th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div
                    id="timespan_participants"
                    *ngIf="!currentPlan.IsActive && !currentPlan.IsReviewing"
                  >
                    <div id="timespan_participants_body">
                      <div
                        id="timespan_participants_body_Employee_typeahead_title"
                      >
                        {{
                          'ADMIN_LTI.TIME_PART.BODY.SELECT_PARTICIPANTS'
                            | translate
                        }}
                      </div>
                      <div class="display-flex-left flex-align-center">
                        <div class="input-compare-item">
                          <input
                            id="timespan_participants_body_input_typeahead"
                            [(ngModel)]="searchedEmployee"
                            placeholder="{{
                              'Generic.SearchEmployee' | translate
                            }}"
                            [typeaheadMinLength]="0"
                            [typeahead]="getFilteredEmployeeList()"
                            [typeaheadOptionsLimit]="employeesList.length"
                            (typeaheadOnSelect)="onSelectEmployee($event?.item)"
                            [ngClass]="{ 'bg-blue': searchedSkill }"
                            [typeaheadItemTemplate]="employeeTemplate"
                            typeaheadOptionField="Name"
                            class="form-control pull-right search-skill-input"
                          />
                        </div>
                        <div
                          id="timespan_participants_body_round_container"
                          *ngIf="
                            currentPlan.PartecipantsByYear[0].Partecipants
                              .length > 0
                          "
                        >
                          <div class="display-flex-left flex-align-center">
                            <!-- <div class="form-check">
                              <input class="form-check-input magic-checkbox" [ngModel]="roundBonusValues" (change)="onChangeRoudBonus()" type="checkbox" id="roundBonusValues">
                              <label class="form-check-label" for="roundBonusValues" tooltip="{{'ADMIN_LTI.TIME_PART.BODY.ROUND_BONUS_VALUES' | translate}}">
                                {{'ADMIN_LTI.TIME_PART.BODY.ROUND_BONUS_VALUES' | translate}}
                              </label>
                            </div> -->
                            <i
                              class="adcheck {{
                                roundBonusValues
                                  ? 'fas fa-check'
                                  : 'far fa-square'
                              }}"
                              (click)="onChangeRoudBonus()"
                              tooltip="{{
                                'ADMIN_LTI.TIME_PART.BODY.ROUND_BONUS_VALUES'
                                  | translate
                              }}"
                            ></i>
                            <div
                              class="display-flex-left flex-align-center"
                              *ngIf="roundBonusValues"
                            >
                              <div class="" style="width: 10px">&nbsp;</div>
                              <input
                                type="text"
                                name=""
                                class="form-control"
                                [(ngModel)]="currentPlan.RoundBonusValue"
                              />
                              <div class="" style="width: 10px">&nbsp;</div>
                              <!-- <div class="form-check">
                                <input [(ngModel)]="currentPlan.RoundBonusFlag" class="form-check-input magic-radio" name="RoundBonusFlag" type="radio" id="radioUp" value="Up">
                                <label class="form-check-label" for="radioUp" tooltip="{{'ADMIN_LTI.TIME_PART.BODY.UP' | translate}}">
                                  {{'ADMIN_LTI.TIME_PART.BODY.UP' | translate}}
                                </label>
                              </div> -->
                              <i
                                class="adradio {{
                                  currentPlan.RoundBonusFlag == 'Up'
                                    ? 'fas fa-dot-circle'
                                    : 'far fa-circle'
                                }}"
                                (click)="currentPlan.RoundBonusFlag = 'Up'"
                                tooltip="{{
                                  'ADMIN_LTI.TIME_PART.BODY.UP' | translate
                                }}"
                              ></i>
                              <div style="white-space: nowrap">
                                {{ 'ADMIN_LTI.TIME_PART.BODY.UP' | translate }}
                              </div>
                              <div class="" style="width: 10px">&nbsp;</div>
                              <!-- <div class="form-check">
                                <input [(ngModel)]="currentPlan.RoundBonusFlag" class="form-check-input magic-radio" name="RoundBonusFlag" type="radio" id="radioDown" value="Down">
                                <label class="form-check-label" for="radioDown" tooltip="{{'ADMIN_LTI.TIME_PART.BODY.DOWN' | translate}}">
                                  {{'ADMIN_LTI.TIME_PART.BODY.DOWN' | translate}}
                                </label>
                              </div> -->
                              <i
                                class="adradio {{
                                  currentPlan.RoundBonusFlag == 'Down'
                                    ? 'fas fa-dot-circle'
                                    : 'far fa-circle'
                                }}"
                                (click)="currentPlan.RoundBonusFlag = 'Down'"
                                tooltip="{{
                                  'ADMIN_LTI.TIME_PART.BODY.DOWN' | translate
                                }}"
                              ></i>
                              <div style="white-space: nowrap">
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.DOWN' | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="timespan_participants_body_paticipants_list_container"
                        *ngIf="
                          currentPlan.PartecipantsByYear[0].Partecipants
                            .length > 0
                        "
                      >
                        <table>
                          <thead>
                            <tr>
                              <th>
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.PARTICIPANTS_LIST_TABLE.TH.EMPLOYEE'
                                    | translate
                                }}
                              </th>
                              <th>
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.PARTICIPANTS_LIST_TABLE.TH.RAL'
                                    | translate
                                }}
                              </th>
                              <th>
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.PARTICIPANTS_LIST_TABLE.TH.TARGET_BONUS_PERC'
                                    | translate
                                }}
                              </th>
                              <th>
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.PARTICIPANTS_LIST_TABLE.TH.TARGET_BONUS_CURR'
                                    | translate
                                }}({{ parameters.Currency }})
                              </th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="
                                let participant of currentPlan
                                  .PartecipantsByYear[0].Partecipants;
                                let i = index
                              "
                            >
                              <td class="participantEmployee">
                                <div
                                  class="display-flex-left flex-align-center"
                                >
                                  <img
                                    class="user-image-round-bordered"
                                    [src]="
                                      coreService.getImageURL(
                                        participant.Picture,
                                        'assets/images/user.jpeg'
                                      )
                                    "
                                  />
                                  <div class="participantEmployeeName">
                                    {{ participant.SecondName }}
                                    {{ participant.FirstName }}
                                  </div>
                                </div>
                              </td>
                              <td class="participantGrossAnnualSalary">
                                <div class="input-group">
                                  <input
                                    OnlyNumber="true"
                                    (keyup)="checkTargetBonus(participant)"
                                    type="text"
                                    name=""
                                    [(ngModel)]="participant.GrossAnnualSalary"
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      {{ parameters.Currency }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td class="participantTargetBonusPercentage">
                                <div class="input-group">
                                  <input
                                    OnlyNumber="true"
                                    (keyup)="checkTargetBonus(participant)"
                                    type="text"
                                    name=""
                                    [(ngModel)]="
                                      participant.TargetBonusPercentage
                                    "
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <span class="input-group-text">%</span>
                                  </div>
                                </div>
                              </td>
                              <td class="participantTargetBonus">
                                <div class="input-group">
                                  <input
                                    OnlyNumber="true"
                                    type="text"
                                    name=""
                                    [ngModel]="
                                      formatNumber(participant.TargetBonus, 2)
                                    "
                                    class="form-control"
                                    disabled
                                  />
                                  <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      {{ parameters.Currency }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td class="participantAction">
                                <a
                                  class="text-grey"
                                  (click)="removeParticipant(i)"
                                >
                                  <i class="fa fa-trash"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="2" class="total">
                                {{
                                  'ADMIN_LTI.TIME_PART.BODY.PARTICIPANTS_LIST_TABLE.TFOOT.TOTAL'
                                    | translate
                                }}
                              </th>
                              <th colspan="2" class="text-right">
                                {{ formatNumber(getTotTable()) }}
                              </th>
                              <th></th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </tab>
                <!-- Time Span & Participants -->
                <!-- Gateways -->
                <tab
                  (selectTab)="onSelectTab($event, 1)"
                  heading="{{ 'ADMIN_LTI.TABS.GATEWAYS' | translate }}"
                >
                  <div id="gateways">
                    <div id="gateways_body">
                      <div id="gateways_body-head">
                        <div id="gateways_body-head-totals">
                          <table>
                            <tr>
                              <th>
                                {{
                                  'ADMIN_LTI.GATEWAYS.BODY.TARGET_BONUS'
                                    | translate
                                }}
                              </th>
                              <td>{{ getGatewayTargetBonus() }}</td>
                            </tr>
                            <tr>
                              <th>
                                {{
                                  'ADMIN_LTI.GATEWAYS.BODY.TARGET_BONUS_MULTIPLIER'
                                    | translate
                                }}
                              </th>
                              <td>
                                {{ getGatewayTargetBonusMultiplier() }}
                                <strong>x</strong>
                              </td>
                            </tr>
                            <tr>
                              <th>
                                {{
                                  'ADMIN_LTI.GATEWAYS.BODY.ADMITTED_BONUS'
                                    | translate
                                }}
                              </th>
                              <td>{{ getAdmittedBonusGateways() }}</td>
                            </tr>
                          </table>
                        </div>
                        <div
                          id="gateways_body-head-add_gateway"
                          (click)="addNewGateway()"
                          *ngIf="
                            !currentPlan.IsActive && !currentPlan.IsReviewing
                          "
                        >
                          {{
                            'ADMIN_LTI.GATEWAYS.BODY.ADD_NEW_GATEWAY'
                              | translate
                              | uppercase
                          }}
                        </div>
                      </div>
                      <div id="gateways_body-list_container">
                        <div id="gateways_body-list_container-head">
                          <div class="">
                            {{
                              'ADMIN_LTI.GATEWAYS.BODY.ALL_GATEWAYS' | translate
                            }}
                          </div>
                          <div class="">{{ getAllGatewayWeight() }}%</div>
                        </div>
                        <div id="gateways_body-list_container-hint">
                          <i class="fa fa-info-circle"></i>
                          &nbsp;
                          {{
                            'PARTECIPANT_LTI.OBJECTIVES.GATEWAYS_HINT'
                              | translate
                          }}
                          <!--{{'ADMIN_LTI.GATEWAYS.BODY.GATEWAYS_INFO' | translate}}-->
                        </div>
                        <div id="gateways_body-list">
                          <app-gateway
                            (deleteItem)="deleteItem($event)"
                            [IsActive]="
                              currentPlan.IsActive || currentPlan.IsReviewing
                            "
                            [item]="item"
                            [type]="'gateway'"
                            [index]="i"
                            *ngFor="
                              let item of currentPlan.Gateways;
                              let i = index
                            "
                          ></app-gateway>
                        </div>
                      </div>
                    </div>
                  </div>
                </tab>
                <!-- Gateways -->
                <!-- Objectives -->
                <tab
                  (selectTab)="onSelectTab($event, 2)"
                  heading="{{ 'ADMIN_LTI.TABS.OBJECTIVES' | translate }}"
                >
                  <div id="gateways">
                    <div id="gateways_body">
                      <div id="gateways_body-head">
                        <div id="gateways_body-head-totals">
                          <table>
                            <tr>
                              <th>
                                {{
                                  'ADMIN_LTI.OBJECTIVES.BODY.ADMITTED_BONUS'
                                    | translate
                                }}
                              </th>
                              <td>{{ getAdmittedBonus() }}</td>
                            </tr>
                            <tr>
                              <th>
                                {{
                                  'ADMIN_LTI.OBJECTIVES.BODY.ADMITTED_BONUS_MULTIPLIER'
                                    | translate
                                }}
                              </th>
                              <td>
                                {{ getObjectiveTargetBonusMultiplier() }}
                                <strong>x</strong>
                              </td>
                            </tr>
                            <tr>
                              <th>
                                {{
                                  'ADMIN_LTI.OBJECTIVES.BODY.ACCRUED_BONUS'
                                    | translate
                                }}
                              </th>
                              <td>{{ getAccruedBonus() }}</td>
                            </tr>
                          </table>
                        </div>
                        <div
                          id="gateways_body-head-add_gateway"
                          (click)="addNewObjective()"
                        >
                          {{
                            'ADMIN_LTI.GATEWAYS.BODY.ADD_NEW_OBJECTIVE'
                              | translate
                              | uppercase
                          }}
                        </div>
                      </div>
                      <div id="gateways_body-list_container">
                        <div id="gateways_body-list_container-head">
                          <div class="">
                            {{
                              'ADMIN_LTI.OBJECTIVES.BODY.ALL_OBJECTIVES'
                                | translate
                            }}
                          </div>
                          <div class="">{{ getAllObjectiveWeight() }}%</div>
                        </div>
                        <div id="gateways_body-list_container-hint">
                          <i class="fa fa-info-circle"></i>
                          &nbsp;
                          {{
                            'PARTECIPANT_LTI.OBJECTIVES.OBJECTIVES_HINT'
                              | translate
                          }}
                          <!--{{'ADMIN_LTI.GATEWAYS.BODY.GATEWAYS_INFO' | translate}}-->
                        </div>
                        <div id="gateways_body-list">
                          <app-gateway
                            (deleteItem)="deleteItem($event)"
                            [IsActive]="currentPlan.IsActive"
                            [item]="item"
                            [type]="'objective'"
                            [index]="i"
                            *ngFor="
                              let item of currentPlan.Objectives;
                              let i = index
                            "
                          ></app-gateway>
                        </div>
                      </div>
                    </div>
                  </div>
                </tab>
                <!-- Objectives -->
                <!-- Payout Structures -->
                <tab
                  (selectTab)="onSelectTab($event, 3)"
                  heading="{{ 'ADMIN_LTI.TABS.PAYOUT' | translate }}"
                >
                  <div id="gateways">
                    <div class="gateways_body">
                      <div id="payout_filter">
                        <div id="payout_filter_type">
                          <div id="payout_filter_type_title">
                            {{
                              'ADMIN_LTI.PAYOUT.BODY.PAYOUT_TYPE' | translate
                            }}
                          </div>
                          <div id="payout_filter_type_radio">
                            <div class="form-check">
                              <input
                                [disabled]="
                                  currentPlan.IsActive ||
                                  currentPlan.IsReviewing
                                "
                                [ngModel]="
                                  currentPlan.PayoutStructure.PayoutType
                                "
                                class="form-check-input magic-radio"
                                name="radioCash"
                                type="radio"
                                id="radioCash"
                                value="Cash"
                              />
                              <label
                                class="form-check-label"
                                for="radioCash"
                                (click)="
                                  currentPlan.PayoutStructure.PayoutType =
                                    'Cash'
                                "
                              >
                                {{ 'ADMIN_LTI.PAYOUT.BODY.CASH' | translate }}
                              </label>
                            </div>
                            <div class="" style="flex: 0 0 20px">&nbsp;</div>
                            <div class="form-check">
                              <input
                                [disabled]="
                                  currentPlan.IsActive ||
                                  currentPlan.IsReviewing
                                "
                                [ngModel]="
                                  currentPlan.PayoutStructure.PayoutType
                                "
                                class="form-check-input magic-radio"
                                name="radioCash"
                                type="radio"
                                id="radioCashEq"
                                value="Equity"
                              />
                              <label
                                class="form-check-label"
                                for="radioCashEq"
                                (click)="
                                  currentPlan.PayoutStructure.PayoutType =
                                    'Equity'
                                "
                              >
                                {{
                                  'ADMIN_LTI.PAYOUT.BODY.CASH_EQUITY'
                                    | translate
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div id="payout_filter_period">
                          <div id="payout_filter_period_title">
                            {{
                              'ADMIN_LTI.PAYOUT.BODY.PAYOUT_PERIOD' | translate
                            }}
                          </div>
                          <div id="payout_filter_period_date">
                            <div
                              class="display-flex-left flex-align-center flex-fill-width"
                            >
                              <label for="">{{ 'FROM' | translate }}</label>
                              <div class="">&nbsp;</div>
                              <select
                                [disabled]="
                                  currentPlan.IsActive ||
                                  currentPlan.IsReviewing
                                "
                                class="form-control"
                                name="sel-activity"
                                [(ngModel)]="
                                  currentPlan.PayoutStructure.PayoutYearStart
                                "
                                (ngModelChange)="onChangePayStructure()"
                              >
                                <option
                                  *ngFor="let year of getPayFromYear()"
                                  [ngValue]="year"
                                >
                                  {{ year }}
                                </option>
                                <!--[disabled]="year>=currentPlan.PayoutStructure.PayoutYearEnd"-->
                              </select>
                            </div>
                            <div class="" style="flex: 0 0 20px">&nbsp;</div>
                            <div
                              class="display-flex-left flex-align-center flex-fill-width"
                            >
                              <label for="">{{ 'TO' | translate }}</label>
                              <div class="">&nbsp;</div>
                              <select
                                [disabled]="
                                  currentPlan.IsActive ||
                                  currentPlan.IsReviewing
                                "
                                class="form-control"
                                name="sel-activity"
                                [(ngModel)]="
                                  currentPlan.PayoutStructure.PayoutYearEnd
                                "
                                (ngModelChange)="onChangePayStructure()"
                              >
                                <option
                                  *ngFor="let year of getPayToYear()"
                                  [ngValue]="year"
                                  [disabled]="
                                    year <
                                    currentPlan.PayoutStructure.PayoutYearStart
                                  "
                                >
                                  {{ year }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="!modelBuilding" id="payout_table">
                        <table class="table">
                          <thead>
                            <tr>
                              <th></th>
                              <th></th>
                              <th
                                id="bonusPayoutRow"
                                class="text-left"
                                [attr.colspan]="
                                  currentPlan.PayoutStructure.PayoutType ==
                                  'Equity'
                                    ? payoutColumns().length * 2
                                    : payoutColumns().length
                                "
                              >
                                {{
                                  'ADMIN_LTI.PAYOUT.BODY.BONUS_PAYOUT'
                                    | translate
                                }}
                              </th>
                              <th></th>
                            </tr>
                            <tr>
                              <th></th>
                              <th></th>
                              <ng-template
                                ngFor
                                let-col="index"
                                [ngForOf]="payoutColumns()"
                              >
                                <th
                                  [attr.colspan]="
                                    currentPlan.PayoutStructure.PayoutType ==
                                    'Equity'
                                      ? 2
                                      : 1
                                  "
                                >
                                  {{
                                    currentPlan.PayoutStructure
                                      .PayoutYearStart + col
                                  }}
                                </th>
                              </ng-template>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngIf="
                                currentPlan.PayoutStructure.PayoutType ==
                                'Equity'
                              "
                            >
                              <th></th>
                              <th></th>
                              <ng-template
                                ngFor
                                let-col="index"
                                [ngForOf]="payoutColumns()"
                                *ngIf="
                                  currentPlan.PayoutStructure.PayoutType ==
                                  'Equity'
                                "
                              >
                                <th>
                                  {{ 'ADMIN_LTI.PAYOUT.BODY.CASH' | translate }}
                                  %
                                </th>
                                <th>
                                  {{
                                    'ADMIN_LTI.PAYOUT.BODY.EQUITY' | translate
                                  }}
                                  %
                                </th>
                              </ng-template>
                              <th></th>
                            </tr>
                            <tr
                              *ngFor="
                                let row of currentPlan.PayoutStructure.Rows;
                                let i = index
                              "
                            >
                              <td
                                id="bonusAccrualCol"
                                *ngIf="i == 0"
                                [attr.rowspan]="
                                  currentPlan.PayoutStructure.Rows.length
                                "
                              >
                                <div class="">
                                  {{
                                    'ADMIN_LTI.PAYOUT.BODY.BONUS_ACCRUAL'
                                      | translate
                                  }}
                                </div>
                              </td>
                              <th>{{ row.AccrueYear }}</th>
                              <ng-container
                                *ngIf="
                                  currentPlan.PayoutStructure.PayoutType ==
                                  'Cash'
                                "
                              >
                                <td *ngFor="let col of row.PayoutValues">
                                  <input
                                    [disabled]="
                                      checkDisabledInput(row, col) ||
                                      currentPlan.IsActive ||
                                      currentPlan.IsReviewing
                                    "
                                    OnlyNumber="true"
                                    [(ngModel)]="col.Cash"
                                    class="form-control"
                                    type="text"
                                  />
                                </td>
                              </ng-container>

                              <ng-container
                                *ngIf="
                                  currentPlan.PayoutStructure.PayoutType ==
                                  'Equity'
                                "
                              >
                                <ng-container
                                  *ngFor="let col of row.PayoutValues"
                                >
                                  <td>
                                    <input
                                      [disabled]="
                                        checkDisabledInput(row, col) ||
                                        currentPlan.IsActive ||
                                        currentPlan.IsReviewing
                                      "
                                      OnlyNumber="true"
                                      [(ngModel)]="col.Cash"
                                      class="form-control"
                                      type="text"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      [disabled]="
                                        checkDisabledInput(row, col) ||
                                        currentPlan.IsActive ||
                                        currentPlan.IsReviewing
                                      "
                                      OnlyNumber="true"
                                      [(ngModel)]="col.Equity"
                                      class="form-control"
                                      type="text"
                                    />
                                  </td>
                                </ng-container>
                              </ng-container>
                              <th class="totalRow">{{ getTotRow(i) }}%</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div id="payout_notes">
                        <small>
                          {{
                            'ADMIN_LTI.PAYOUT.BODY.EXPLANATION_NOTE' | translate
                          }}
                        </small>
                        <textarea
                          [disabled]="
                            currentPlan.IsActive || currentPlan.IsReviewing
                          "
                          class="form-control"
                          name="name"
                          rows="2"
                          [(ngModel)]="currentPlan.PayoutStructure.PayoutNote"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </tab>
                <!-- Payout Structures -->
                <!-- Corrective Objectives -->
                <tab
                  (selectTab)="onSelectTab($event, 4)"
                  heading="{{ 'ADMIN_LTI.TABS.CORRECTIVE' | translate }}"
                >
                  <div id="gateways">
                    <div id="gateways_body">
                      <div id="gateways_body-head">
                        <div id="gateways_body-head-totals">
                          <table>
                            <tr>
                              <th class="giallo">
                                {{
                                  'ADMIN_LTI.CORRECTIVE.BODY.BONUS_BANK_MULTIPLIER'
                                    | translate
                                }}
                              </th>
                              <td class="giallo big bold">
                                {{ getCorrectiveOTargetBonusMultiplier() }}x
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div id="payout_filter_type">
                          <div id="payout_filter_type_title">
                            {{
                              'ADMIN_LTI.CORRECTIVE.BODY.APPLICATION'
                                | translate
                            }}
                          </div>
                          <div id="payout_filter_type_radio">
                            <div class="form-check">
                              <input
                                [disabled]="
                                  currentPlan.IsActive ||
                                  currentPlan.IsReviewing
                                "
                                [checked]="
                                  currentPlan.CorrectiveType == 'Rolling'
                                "
                                class="form-check-input magic-radio"
                                name="CorrectiveType"
                                type="radio"
                                id="radioBB"
                                value="Rolling"
                              />
                              <label
                                class="form-check-label"
                                for="radioUp"
                                (click)="currentPlan.CorrectiveType = 'Rolling'"
                              >
                                {{
                                  'ADMIN_LTI.CORRECTIVE.BODY.ROLLING_BONUS_BANK'
                                    | translate
                                }}
                              </label>
                            </div>
                            <div class="" style="flex: 0 0 20px">&nbsp;</div>
                            <div class="form-check">
                              <input
                                [disabled]="
                                  currentPlan.IsActive ||
                                  currentPlan.IsReviewing
                                "
                                [checked]="
                                  currentPlan.CorrectiveType == 'Final'
                                "
                                class="form-check-input magic-radio"
                                name="CorrectiveType"
                                type="radio"
                                id="radioBB"
                                value="Final"
                              />
                              <label
                                class="form-check-label"
                                for="radioDown"
                                (click)="currentPlan.CorrectiveType = 'Final'"
                              >
                                {{
                                  'ADMIN_LTI.CORRECTIVE.BODY.FINAL_BONUS_BANK'
                                    | translate
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div
                          id="gateways_body-head-add_gateway"
                          (click)="addNewCorrectiveObjective()"
                        >
                          {{
                            'ADMIN_LTI.GATEWAYS.BODY.ADD_NEW_CORRECTIVE_OBJECTIVE'
                              | translate
                              | uppercase
                          }}
                        </div>
                      </div>
                      <div id="gateways_body-list_container">
                        <div id="gateways_body-list_container-head">
                          <div class="">
                            {{
                              'ADMIN_LTI.CORRECTIVE.BODY.ALL_CORRECTIVES'
                                | translate
                            }}
                          </div>
                          <div class="">
                            {{ getAllCorrectiveObjectiveWeight() }}%
                          </div>
                        </div>
                        <div id="gateways_body-list_container-hint">
                          <i class="fa fa-info-circle"></i>
                          &nbsp;
                          {{
                            'PARTECIPANT_LTI.OBJECTIVES.CORRECTIVE_HINT'
                              | translate
                          }}
                          <!--{{'ADMIN_LTI.CORRECTIVE.BODY.CORRECTIVE_INFO' | translate}}-->
                        </div>
                        <div id="gateways_body-list">
                          <app-gateway
                            (deleteItem)="deleteItem($event)"
                            [IsActive]="
                              currentPlan.IsActive || currentPlan.IsReviewing
                            "
                            [item]="item"
                            [type]="'corrective'"
                            [index]="i"
                            *ngFor="
                              let item of currentPlan.Correctives;
                              let i = index
                            "
                          ></app-gateway>
                        </div>
                      </div>
                    </div>
                  </div>
                </tab>
                <!-- Corrective Objectives -->
                <!-- Review & Distribute -->
                <tab
                  (selectTab)="onSelectTab($event, 5)"
                  heading="{{ 'ADMIN_LTI.TABS.REVIEW_DIST' | translate }}"
                >
                  <div id="gateways">
                    <div id="review_body">
                      <div class="row">
                        <div class="col-xs-12 col-md-6">
                          <div class="terms_title">
                            {{ 'ADMIN_LTI.REVIEW_DIST.BODY.TERMS' | translate }}
                          </div>
                          <div class="display-flex-space-between">
                            <div class="flex-fill">
                              <i
                                *ngIf="isUploading"
                                class="fa fa-spinner fa-pulse fa-fw fa-3x footer-default"
                              ></i>
                              <div
                                class="display-flex-left flex-align-center flex-wrap"
                                *ngIf="uploaded || currentPlan.Attachment"
                              >
                                <i
                                  class="fa fa-file-pdf-o fa-3x pointer"
                                  (click)="openPdf(currentPlan.Attachment)"
                                ></i>
                                <br />
                                &nbsp;{{ currentPlan.AttachmentName }}
                              </div>
                            </div>
                            <div
                              class=""
                              *ngIf="
                                !currentPlan.IsActive &&
                                !currentPlan.IsReviewing
                              "
                            >
                              <input
                                [disabled]="isUploading"
                                type="file"
                                style="display: none"
                                id="addDocument"
                                accept="application/pdf"
                                (change)="uploadTerms($event)"
                              />
                              <label
                                for="addDocument"
                                id="review_body-head-add_gateway"
                              >
                                <span>
                                  {{
                                    'ADMIN_LTI.REVIEW_DIST.BODY.UPLOAD_TERMS'
                                      | translate
                                      | uppercase
                                  }}
                                </span>
                              </label>
                            </div>
                          </div>
                          <div class="terms_title">
                            {{
                              'ADMIN_LTI.REVIEW_DIST.BODY.VEXATIOUS_CLAUSES'
                                | translate
                            }}
                          </div>
                          <textarea
                            autosize
                            name="name"
                            rows="3"
                            class="form-control autosize"
                            [(ngModel)]="currentPlan.Clauses"
                          ></textarea>
                          <div class="terms_title">
                            {{
                              'ADMIN_LTI.REVIEW_DIST.BODY.LTI_INTRODUCTORY_NOTE'
                                | translate
                            }}
                          </div>
                          <textarea
                            autosize
                            name="name"
                            rows="3"
                            class="form-control autosize"
                            [(ngModel)]="currentPlan.Note"
                          ></textarea>
                          <div class="terms_title">
                            {{
                              'ADMIN_LTI.REVIEW_DIST.BODY.LTI_EXPLICATIVE_NOTE'
                                | translate
                            }}
                          </div>
                          <textarea
                            autosize
                            name="name"
                            rows="3"
                            class="form-control autosize"
                            [(ngModel)]="currentPlan.Document"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </tab>
                <!-- Review & Distribute -->
              </tabset>
            </div>

            <div
              id="rightSidebar"
              [ngClass]="{
                'more-padding-top-box':
                  currentTabIndex == 0 &&
                  !currentPlan.IsActive &&
                  !currentPlan.IsReviewing,
                'padding-top-box':
                  currentTabIndex > 0 ||
                  currentPlan.IsActive ||
                  currentPlan.IsReviewing
              }"
            >
              <div class="">
                <app-summary-box
                  [type]="'before'"
                  [yellowBox]="yellowBox()"
                  [plan]="currentPlan"
                  [originalPlan]="originalPlan"
                  [currentYear]="currentYear"
                ></app-summary-box>
                <br />
                <app-summary-box
                  [type]="'after'"
                  [yellowBox]="'true'"
                  *ngIf="
                    (currentPlan.IsActive || currentPlan.IsReviewing) &&
                    editParticipants
                  "
                  [plan]="currentPlan"
                  [originalPlan]="originalPlan"
                  [currentYear]="currentYear"
                ></app-summary-box>

                <div id="ledIndicators" *ngIf="currentPlan">
                  <div class="display-flex-space-between">
                    <span>{{ 'ADMIN_LTI.TABS.TIME_PART' | translate }}</span>
                    <i
                      class="fa fa-circle"
                      [ngClass]="
                        currentPlan.Status
                          ? currentPlan.Status.partecipants
                          : ''
                      "
                    ></i>
                  </div>
                  <div class="display-flex-space-between">
                    <span>{{ 'ADMIN_LTI.TABS.GATEWAYS' | translate }}</span>
                    <i
                      class="fa fa-circle"
                      [ngClass]="
                        currentPlan.Status ? currentPlan.Status.gateways : ''
                      "
                    ></i>
                  </div>

                  <div class="display-flex-space-between">
                    <span>{{ 'ADMIN_LTI.TABS.OBJECTIVES' | translate }}</span>
                    <i
                      class="fa fa-circle"
                      [ngClass]="
                        currentPlan.Status ? currentPlan.Status.objectives : ''
                      "
                    ></i>
                  </div>
                  <div class="display-flex-space-between">
                    <span>{{ 'ADMIN_LTI.TABS.PAYOUT' | translate }}</span>
                    <i
                      class="fa fa-circle"
                      [ngClass]="
                        currentPlan.Status ? currentPlan.Status.payout : ''
                      "
                    ></i>
                  </div>
                  <div class="display-flex-space-between">
                    <span>{{ 'ADMIN_LTI.TABS.CORRECTIVE' | translate }}</span>
                    <i
                      class="fa fa-circle"
                      [ngClass]="
                        currentPlan.Status ? currentPlan.Status.correctives : ''
                      "
                    ></i>
                  </div>
                  <div class="display-flex-space-between">
                    <span>{{ 'ADMIN_LTI.TABS.REVIEW_DIST' | translate }}</span>
                    <i
                      class="fa fa-circle"
                      [ngClass]="
                        currentPlan.Status ? currentPlan.Status.documents : ''
                      "
                    ></i>
                  </div>
                  <br />
                  <div
                    *ngIf="
                      currentPlan.Status &&
                      currentPlan.Status.gatewaysOrobjectives() != 'complete'
                    "
                  >
                    <i class="fa fa-warning footer-default"></i>
                    {{ 'ADMIN_LTI.ATLEASTGATEWAY' | translate }}
                  </div>
                </div>
              </div>

              <div
                id="actionsButtons"
                *ngIf="
                  currentPlan &&
                  !currentPlan.IsActive &&
                  !currentPlan.IsReviewing
                "
              >
                <button class="actionButton" (click)="sendDraft()">
                  {{ 'ADMIN_LTI.SEND_DRAFT' | translate | uppercase }}
                </button>
                <button class="actionButton white" (click)="deleteDraft()">
                  {{ 'ADMIN_LTI.DELETE_DRAFT' | translate | uppercase }}
                </button>
              </div>

              <div
                id="actionsButtons"
                *ngIf="
                  currentPlan &&
                  (currentPlan.IsActive || currentPlan.IsReviewing) &&
                  !editParticipants
                "
              >
                <button
                  class="actionButton white"
                  (click)="enableEditParticipants()"
                >
                  {{ 'ADMIN_LTI.EDIT_PLAN' | translate | uppercase }}
                </button>
              </div>

              <div
                id="actionsButtons"
                *ngIf="editParticipants && currentTabIndex === 0"
              >
                <button class="actionButton white" (click)="cancelDraft()">
                  {{ 'CANCEL' | translate | titlecase }}
                </button>
                <button class="actionButton" (click)="sendDraft()">
                  {{ 'SAVE' | translate | titlecase }}
                </button>
              </div>

              <div id="actionsButtons" *ngIf="currentPlan">
                <button
                  class="actionButton"
                  id="review_body-head-add_gateway"
                  (click)="sendLtiTerms()"
                  [disabled]="checkDisabled()"
                  [ngClass]="
                    checkDisabled() ? 'sendRequestDisabled' : 'sendRequest'
                  "
                >
                  <span
                    *ngIf="!currentPlan.IsActive && !currentPlan.IsReviewing"
                  >
                    {{
                      'ADMIN_LTI.REVIEW_DIST.BODY.SEND_LTI_TERMS'
                        | translate
                        | uppercase
                    }}
                  </span>
                  <span *ngIf="currentPlan.IsActive || currentPlan.IsReviewing">
                    {{
                      'ADMIN_LTI.REVIEW_DIST.BODY.RESEND_LTI_TERMS'
                        | translate
                        | uppercase
                    }}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #employeeTemplate let-model="item" let-index="index">
  <div class="template-compare-employee display-flex-left flex-align-center">
    <div class="template-compare-employee-image">
      <img
        class="user-image-round-bordered"
        [src]="
          coreService.getImageURL(model.Picture, 'assets/images/user.jpeg')
        "
      />
    </div>
    <div class="template-compare-employee-info">
      <div class="template-compare-employee-name">
        {{ model.SecondName }} {{ model.FirstName }}
      </div>
      <div class="template-compare-employee-jobtitle">
        {{ model.JobTitle }}
      </div>
      <div class="template-compare-employee-location">
        {{ model.Location }}
      </div>
    </div>
  </div>
</ng-template>
